// extracted by mini-css-extract-plugin
export default {"Container":"UserInfoSection_Container__vM7Ii","TextContainer":"UserInfoSection_TextContainer__e7hj-","Name":"UserInfoSection_Name__AJxzZ","Email":"UserInfoSection_Email__d7tgS"};